import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  FiMenu,
  FiHome,
  FiSettings,
  FiLogOut,
  FiUser,
  FiPhone,
  FiMail,
} from "react-icons/fi";

const Layout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const menuItems = [
    {
      path: "/dashboard",
      icon: FiHome,
      label: "Dashboard",
    },
    {
      path: "/test/voice",
      icon: FiPhone,
      label: "Voice test",
    },
    {
      path: "/test/email",
      icon: FiMail,
      label: "Email test",
    },
    {
      path: "/settings",
      icon: FiSettings,
      label: "Settings",
    },
  ];

  return (
    <div className="layout">
      <aside className={`sidebar ${sidebarCollapsed ? "collapsed" : ""}`}>
        <div className="sidebar-header">
          <div className="logo">{!sidebarCollapsed && "PSPS Admin"}</div>
          <button className="sidebar-toggle" onClick={toggleSidebar}>
            <FiMenu />
          </button>
        </div>

        <nav>
          <ul className="sidebar-menu">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;

              return (
                <li key={item.path} className="menu-item">
                  <Link
                    to={item.path}
                    className={`menu-link ${isActive ? "active" : ""}`}
                  >
                    <Icon className="menu-icon" />
                    <span className="menu-text">{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </aside>

      <main className="main-content">
        <header className="header">
          <h1 className="header-title">Admin Dashboard</h1>
          <div className="header-actions">
            <div className="user-info">
              <FiUser />
              <span>{user?.name}</span>
            </div>
            <button className="logout-button" onClick={logout}>
              <FiLogOut />
              Logout
            </button>
          </div>
        </header>

        <div className="content">{children}</div>
      </main>
    </div>
  );
};

export default Layout;
